package io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.icons

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import io.github.kingsword09.symbolcraft.symbols.icons.materialsymbols.Icons

public val Icons.RefreshW500Rounded: ImageVector
    get() {
        if (_refreshW500Rounded != null) {
            return _refreshW500Rounded!!
        }
        _refreshW500Rounded = Builder(name = "RefreshW500Rounded", defaultWidth = 24.0.dp, defaultHeight = 24.0.dp, viewportWidth = 960.0f, viewportHeight = 960.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f, strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f, pathFillType = NonZero) {
                moveTo(479.04f, 808.13f)
                quadToRelative(-137.11f, 0.0f, -232.62f, -95.51f)
                quadToRelative(-95.51f, -95.51f, -95.51f, -232.62f)
                reflectiveQuadToRelative(95.51f, -232.62f)
                quadToRelative(95.51f, -95.51f, 232.62f, -95.51f)
                quadToRelative(71.16f, 0.0f, 135.71f, 29.22f)
                quadToRelative(64.55f, 29.21f, 110.51f, 83.89f)
                verticalLineToRelative(-71.2f)
                quadToRelative(0.0f, -17.71f, 12.1f, -29.81f)
                quadToRelative(12.1f, -12.1f, 29.81f, -12.1f)
                quadToRelative(17.72f, 0.0f, 29.82f, 12.1f)
                quadToRelative(12.1f, 12.1f, 12.1f, 29.81f)
                verticalLineToRelative(204.31f)
                quadToRelative(0.0f, 19.15f, -13.18f, 32.32f)
                quadToRelative(-13.17f, 13.18f, -32.32f, 13.18f)
                lineTo(558.8f, 443.59f)
                quadToRelative(-17.71f, 0.0f, -29.69f, -12.1f)
                reflectiveQuadToRelative(-11.98f, -29.82f)
                quadToRelative(0.0f, -17.71f, 12.1f, -29.69f)
                reflectiveQuadTo(559.04f, 360.0f)
                lineTo(683.7f, 360.0f)
                quadToRelative(-32.0f, -54.57f, -86.43f, -85.85f)
                quadToRelative(-54.42f, -31.28f, -118.23f, -31.28f)
                quadToRelative(-98.8f, 0.0f, -167.96f, 69.16f)
                quadTo(241.91f, 381.2f, 241.91f, 480.0f)
                reflectiveQuadToRelative(69.17f, 167.97f)
                quadToRelative(69.16f, 69.16f, 167.96f, 69.16f)
                quadToRelative(65.37f, 0.0f, 120.08f, -32.71f)
                quadToRelative(54.71f, -32.7f, 85.95f, -87.59f)
                quadToRelative(9.43f, -15.44f, 26.32f, -21.54f)
                quadToRelative(16.89f, -6.09f, 33.81f, -0.14f)
                quadToRelative(17.91f, 5.96f, 25.87f, 23.39f)
                quadToRelative(7.95f, 17.44f, -1.0f, 32.87f)
                quadToRelative(-42.44f, 80.24f, -119.75f, 128.48f)
                quadToRelative(-77.32f, 48.24f, -171.28f, 48.24f)
                close()
            }
        }
        .build()
        return _refreshW500Rounded!!
    }

private var _refreshW500Rounded: ImageVector? = null
